import { render, staticRenderFns } from "./device-qrcode.vue?vue&type=template&id=2673821c&scoped=true"
import script from "./device-qrcode.vue?vue&type=script&lang=js"
export * from "./device-qrcode.vue?vue&type=script&lang=js"
import style0 from "./device-qrcode.vue?vue&type=style&index=0&id=2673821c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673821c",
  null
  
)

export default component.exports